/* ============================================================
   OSZEA — Shoe Care Guide  (Shopify section script)
   Cleaning-method tabs (desktop) / accordion (mobile).
   Loads alongside oszea-support.js, which handles the shared
   reveal animation, FAQ accordion, smooth scroll, rain canvas,
   sticky help and toast for .oszea-sp sections.
   ============================================================ */
(function () {
  'use strict';
  var isMobile = function () { return window.matchMedia('(max-width: 820px)').matches; };

  function initTabs(cm) {
    var tabs = Array.prototype.slice.call(cm.querySelectorAll('.cm-tab'));
    var panels = Array.prototype.slice.call(cm.querySelectorAll('.cm-panel'));
    var heads = Array.prototype.slice.call(cm.querySelectorAll('.cm-acc-head'));

    function activate(i) {
      tabs.forEach(function (t, idx) {
        var on = idx === i;
        t.classList.toggle('active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p, idx) { p.classList.toggle('active', idx === i); });
    }

    tabs.forEach(function (t, i) { t.addEventListener('click', function () { activate(i); }); });
    heads.forEach(function (h, i) {
      h.addEventListener('click', function () {
        if (!isMobile()) { activate(i); return; }
        var open = panels[i].classList.contains('active');
        activate(open ? -1 : i);
      });
    });
    window.addEventListener('resize', function () {
      if (!isMobile()) {
        var any = panels.some(function (p) { return p.classList.contains('active'); });
        if (!any) activate(0);
      }
    }, { passive: true });

    activate(0);
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('.oszea-sp .cm')).forEach(initTabs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Shopify Theme Editor — re-init when the section is reloaded */
  document.addEventListener('shopify:section:load', function (e) {
    var cm = e.target.querySelector('.cm');
    if (cm) initTabs(cm);
  });
})();
